<div ui-view>
  <neo-list data="vm.data"></neo-list>
  <div>
  <neo-action-button buttons="vm.buttons" ng-if="vm.buttons.actions.length > 0"></neo-action-button>
</div>
</div>

